<net-status *ngIf="phoneEngineReady()"></net-status>
<mat-toolbar class="main-header gradient-background">
  <button (click)="toggleSidenav.emit()" mat-icon-button>
    <mat-icon>menu</mat-icon>
  </button>
  <div class="branding">
    <img src="assets/images/logo-white.png" alt="Smart Contact" title="Smart Contact" />
  </div>
  <div class="search-bar" fxFlex>
    <form class="search-form" fxHide>
      <mat-icon>search</mat-icon>
      <input type="text" placeholder="Search" autofocus="true" />
    </form>
  </div>
  <!-- <button (click)="toggleNotificationSidenav.emit()" mat-icon-button data-ci="notification" [matTooltip]="'phone_header.today_stats'|translate">
    <mat-icon>notifications</mat-icon> -->
    <!-- <span class="notification-label">5</span> -->
  <!-- </button> -->
  <button mat-icon-button (click)="openPageSettings()" data-ci="settings" [matTooltip]="'phone_header.setting_hint'|translate">
    <mat-icon>settings</mat-icon>
  </button>
  <!-- <button mat-icon-button (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
  </button> -->
</mat-toolbar>

<div class="global-player-wrapper" fxLayoutAlign="end start" fxLayoutAlign.xs="center start" [hidden]="!isPlayerVisible()">
  <fileentry-player class="player" fxFlex="350px" fxFlex.xs="100"></fileentry-player>
</div>
